<template>
  <div>
    <button class="btn btn-info-button" v-if="!showLogs" @click="loadLogs">
      Show logs
    </button>
    <div
      v-else-if="loadingLogs"
      class="h-60 flex flex-col items-center justify-center"
    >
      <baseMiniSpinner></baseMiniSpinner>
    </div>
    <div v-else>
      <div v-if="logs" class="grid grid-cols-2 gap-4">
        <div class="flex flex-col gap-2">
          <h3 class="font-bold">
            Logs
          </h3>
          <div
            v-for="log in logs.logs"
            :key="log.id"
            class="flex flex-col gap-2 rounded-md border p-1"
            :class="{ 'text-red-700 font-bold': log.data.includes('deleted') }"
          >
            <div class="grid grid-cols-2">
              <p>{{ log.name }}</p>
              <p>{{ log.nkrCode }}</p>
              <p>{{ log.updateType }}</p>
              <p class="font-bold">{{ formatDateWithHour(log.date) }}</p>
            </div>
            <p>{{ log.data }}</p>
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <h3 class="font-bold">
            Files found
          </h3>
          <div
            class="grid grid-cols-2 gap-2 rounded-md border p-1"
            v-for="file in logs.s3"
            :key="file.Key"
          >
            <img :src="file.url" />
            <div>
              <p class="font-bold">
                {{ formatDateWithHour2(file.LastModified) }}
              </p>
              <p>{{ file.folder }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>No logs found</p>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDateWithHour } from "@/helpers/globalHelpers.js";
import { getImagesLogs } from "@/api/masterAdmin/ProductImagesService";
export default {
  name: "ProductImagesLogs",
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showLogs: false,
      loadingLogs: false,
      logs: null
    };
  },
  methods: {
    async loadLogs() {
      this.showLogs = true;
      console.log("Loading logs");
      this.loadingLogs = true;
      try {
        // Call API to get logs
        await this.getLogs();
        this.showLogs = true;
      } catch (error) {
        console.error(error);
      }
      this.loadingLogs = false;
    },
    async getLogs() {
      this.logs = await getImagesLogs(this.code).then(response => {
        console.log("Logs", response);
        return response;
      });
    },
    formatDateWithHour,
    formatDateWithHour2(date) {
      return formatDateWithHour(date.replace("T", " ").replace("Z", ""));
    }
  }
};
</script>
